/**
 * Opens a non-previewable attachment in a new tab (E2E-37, IP-16281 issue 2).
 *
 * Deliberately NOT `anchor.download`: that attribute is ignored for cross-origin URLs, and these
 * files are served from CloudFront. The browser therefore treated it as a plain navigation and
 * replaced the building page with the raw file — losing the user's place in the table. A new tab
 * keeps the building page intact, which is what the ticket asks for.
 *
 * `rel="noopener"` because `target="_blank"` otherwise hands the opened page a `window.opener`
 * handle back to this one.
 */
export function openAttachmentInNewTab(url) {
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.target = '_blank';
    anchor.rel = 'noopener';
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
}
